export { default as PartnerDataForm } from './PartnerDataForm';
export { default as PartnerDetailsTab } from './PartnerDetailsTab';
export { default as PartnerDetails } from './PartnerDetails';
export { default as PartnerFunds } from './PartnerFunds';
export { default as PartnerFundsTab } from './PartnerFundsTab';